import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { router } from '@/app/router'
import '@/styles/globals.css'

const root = document.getElementById('root')
if (!root) {
  throw new Error('Root element #root not found')
}

const tree = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)

if (root.firstElementChild) {
  hydrateRoot(root, tree)
} else {
  createRoot(root).render(tree)
}
